module.exports = __webpack_public_path__ + "img/4fb4162.jpg";